export default {
  "content": "<path d=\"M9.879 17.88a3 3 0 014.242 0L12 20l-2.121-2.12z\" fill=\"#7B61FF\"/><path d=\"M23.604 3.798L19.962 6.55a15.207 15.207 0 012.623 2.223l-1.372 1.455A13.125 13.125 0 0018.23 7.86l-1.91 1.444a10.93 10.93 0 013.436 2.469l-1.372 1.455a8.882 8.882 0 00-3.996-2.463l-2.438 1.843c1.8-.014 3.604.708 4.978 2.165l-1.372 1.455c-1.965-2.084-5.15-2.084-7.114 0l-.533-.566-4.806 3.636-1.208-1.596 9.607-7.264c-2.143.124-4.251 1.054-5.888 2.79l-1.372-1.455c2.65-2.811 6.319-3.882 9.746-3.215l2.186-1.652c-4.545-1.627-9.768-.52-13.389 3.322L1.415 8.773C5.916 3.998 12.57 2.9 18.062 5.479l4.334-3.277 1.207 1.596z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};